export default "__VITE_ASSET__DKWSCgY___"